import { initExperiment } from "utils/experiment-enrolment"

// The CTA is hidden from the --large-up breakpoint (59.25rem, postcss.config.js) upwards.
const MOBILE_QUERY = "not all and (min-width: 59.25rem)"

// Enrols on the first page load where the CTA can show. Exposure is measured on the header bar,
// because the control arm's CTA container is empty and never counts as visible.
export function initHeaderCtaExperiment(element: HTMLElement, headerBar: HTMLElement) {
  const viewport = window.matchMedia(MOBILE_QUERY)
  const start = () => {
    if (!viewport.matches) return

    try {
      initExperiment(element, { exposureElement: headerBar })
    } catch {
      // Analytics failures must not prevent the header from initializing.
    }
    viewport.removeListener(start)
  }
  viewport.addListener(start)
  start()
}
